import { render, staticRenderFns } from "./StandingCommitteeBill.vue?vue&type=template&id=0d869972&scoped=true"
import script from "./StandingCommitteeBill.vue?vue&type=script&lang=js"
export * from "./StandingCommitteeBill.vue?vue&type=script&lang=js"
import style0 from "./StandingCommitteeBill.vue?vue&type=style&index=0&id=0d869972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d869972",
  null
  
)

export default component.exports